var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c(
        "div",
        { staticClass: "page-inner" },
        [
          _c("router-link", {
            tag: "i",
            staticClass: "icon icon-logo_xiangyun",
            attrs: { to: { name: "index" } }
          }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "link-group" },
            [
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "index" } }
                },
                [_vm._v("首页")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "activitycenter" } }
                },
                [_vm._v("\n        活动中心\n      ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "productcenter" } }
                },
                [_vm._v("\n        产品中心\n      ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "recruitment" } }
                },
                [_vm._v("\n        招贤纳士\n      ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "aboutus" } }
                },
                [_vm._v("\n        关于我们\n      ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  tag: "li",
                  staticClass: "link",
                  attrs: { to: { name: "personal" } }
                },
                [_vm._v("\n        个人中心\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("i", { staticClass: "icon" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user" },
            [
              !_vm.loginedUser
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      on: {
                        click: function($event) {
                          _vm.loginModalVisible = true
                        }
                      }
                    },
                    [_vm._v("登录")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loginedUser
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn logined",
                      staticStyle: {
                        "max-width": "90px",
                        "vertical-align": "middle"
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.loginedUser.nickname) + " "),
                      _c("i", { staticClass: "el-icon-caret-bottom" })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loginedUser,
                      expression: "loginedUser"
                    }
                  ],
                  staticClass: "logined-popover"
                },
                [
                  _c("ul", [
                    _c("li", { on: { click: _vm.showUserInfo } }, [
                      _vm._v("个人信息")
                    ]),
                    _vm._v(" "),
                    _c("li", { on: { click: _vm.logout } }, [
                      _vm._v("退出登录")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("modal", {
        attrs: { open: _vm.loginModalVisible },
        on: {
          "update:open": function($event) {
            _vm.loginModalVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c("modal", {
        attrs: {
          open: _vm.userModalVisible,
          mode: "userInfo",
          userInfo: _vm.loginedUser
        },
        on: {
          "update:open": function($event) {
            _vm.userModalVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("em"),
      _vm._v(" "),
      _c("span")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 